import React, { Component } from 'react';
import "./index.scss";

class Chart extends Component {

    render() {
        return (
            <div className="t7_5-chart">
                <div id="row1" className="t7_2-chart-content first"></div>
                <div id="row2" className="t7_2-chart-content"></div>
                <div id="row3" className="t7_2-chart-content"></div>
            </div>
        );
    }
}

export default Chart;


// WEBPACK FOOTER //
// ./src/hr/table/9.0/components/Chart.js